import ajaxRequest from './ajax'
import qs from "qs"

//我的信息
export const me = () => {
    return ajaxRequest.get("user/me")
}

//更新我的信息
export const update_me = params => {
    return ajaxRequest.post("user/update_me", params)
}

//获取我的跳转key
export const begin_user_admin_site_promotion = () => {
    return ajaxRequest.post("user/begin_user_admin_site_promotion");
}

export const upload_user_avatar = data => {
    return ajaxRequest.post("user/upload_user_avatar", data, { headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } })
}

export const ping = params => {
    return ajaxRequest.get("user/ping?" + qs.stringify(params))
}

export const send_sms_validation_code = params => {
    return ajaxRequest.post("user/send_sms_validation_code?" + qs.stringify(params).replace("%2B", "+"))
}

export const check_sms_validation_code_update_phone = params => {
    return ajaxRequest.post("user/check_sms_validation_code_update_phone?" + qs.stringify(params))
}

export const begin_phone_email_verfication = params => {
    return ajaxRequest.post("user/begin_phone_email_verfication", params)
}

export const end_phone_email_verfication = params => {
    return ajaxRequest.post("user/end_phone_email_verfication", params)
}

export const generate_user_qrcode = params => {
  return ajaxRequest.post("user/generate_user_qrcode")
}

export const get_user_by_token = params => {
  return ajaxRequest.get("user/get_user_by_token", {headers: {Token: params.token}})
}


//获取字典的值
export const load_dictionary = params => {
  return ajaxRequest.get('user/load_dictionary?' + qs.stringify(params));
}

// 邮箱密码验证
export const verfiy_password_login_by_email = params => {
  return ajaxRequest.post("authentication/verfiy_password_login_by_email", params)
}
// 手机密码验证
export const verfiy_password_login_by_phone = params => {
  return ajaxRequest.post("authentication/verfiy_password_login_by_phone", params)
}

// 修改密码时候的密码验证
export const verify_old_password = params => {
  return ajaxRequest.post("user/verify_old_password", params)
}


export const prefix_list = [
    {
        key: "+86",
        value: "+86",
    },
    {
        key: "+852",
        value: "+852",
    },
    {
        key: "+853",
        value: "+853",
    },
    {
        key: "+886",
        value: "+886",
    },
]

export const gender_list = [
    "female",
    "male"
]



// WEBPACK FOOTER //
// ./src/api/user.js